import VIcon from './VIcon';

VIcon.install = function install(Vue) {
  Vue.component(VIcon.name, VIcon);
};

export default VIcon;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VIcon/index.js
// module id = 7M7f
// module chunks = 0